
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;

			
function openModal() {
  document.getElementById("myModal").style.display = "block";
}

function closeModal() {
  document.getElementById("myModal").style.display = "none";
}

var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("demo");
  var captionText = document.getElementById("caption");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
 
}
import { DataTableDirective } from 'angular-datatables';
// import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  slideIndex : 1;
  n:any;
constructor() { }

  ngOnInit(): void {
  }
}


// WEBPACK FOOTER //
// ./src/app/home/gallery/gallery.component.ts